import styled, { css } from 'styled-components'

import Video from '../Video'
import { sizes } from '../../theme'
import { WysiwygContainer } from '../WysiwygRenderer/styled'

export const Container = styled.div`
  flex: 0 0 auto;
  display: flex;
  flex-flow: column;
  max-width: ${`${sizes.tablet / 10}rem` ?? '400rem'};
  height: auto;
  margin-left: auto;
  margin-right: auto;
  border-radius: 2rem;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.pureWhite};
`
export const ImageWrapper = styled.div`
  position: relative;
  border-radius: 2rem;
  overflow: hidden;
  height: 20rem;
`
export const VideoWrapper = styled(Video)`
  & > button {
    margin-right: 3rem;
  }
  & > button + div {
    margin-left: 3rem;
    margin-right: 3rem;
  }
`
const commonTextStyles = css`
  padding-top: 2rem;
  padding-bottom: 2rem;
  margin-left: 3rem;
  margin-right: 3rem;
  &:last-child:first-child {
    padding-bottom: 2.5rem;
  }
`

export const Text = styled(WysiwygContainer)`
  ${commonTextStyles}
  ${({ theme }) => theme.fonts.HelveticaNeueMedium}
  font-size: 1.9rem;
  text-align: center;
  & b,
  & strong {
    ${({ theme }) => theme.fonts.HelveticaNeueBold}
  }
`
export const Ingredients = styled.dl`
  ${commonTextStyles}
  &:not(:first-child) {
    border-top: 1px solid ${({ theme }) => theme.colors.greyDD};
  }
  ${ImageWrapper} + &,
  ${VideoWrapper} + & {
    margin-top: 2rem;
  }
`
export const Ingredient = styled.div`
  ${({ theme }) => theme.textStyles.text_16}
  &:not(:first-child) {
    margin-top: 1.5rem;
  }
  & dt {
    ${({ theme }) => theme.fonts.HelveticaNeueBold}
  }
  & dd {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    &:not(:first-child) {
      margin-top: 0.3rem;
    }
    & > *:nth-child(2) {
      padding-left: 3rem;
      text-align: right;
    }
  }
`
